@if (notifications.length != 0) {
  <div class="notifications-container">
    @for (notification of notifications; track notification) {
      <rt-notification
        (closing)="this.clearNotification(notification)"
        [notification]="notification"
      ></rt-notification>
    }
  </div>
}
